import React from 'react';
import './XSCard.css';
import clsx from 'clsx';
import { XSLayer, XSLayerInput } from '../layer/XSLayer';

export type XSCardInput = XSLayerInput;

export function XSCard(input: XSCardInput) {
    return <XSLayer {...input} className={clsx(input.className, 'XSCard')} />;
}
